import {
	ELanguage,
	Services,
	Toast,
	Container
} from '@microfrontends/react-components'
import { TransContext } from '../../context/TransContext'
import { translator } from '../../helpers/translation'
import { translate } from './translate'
import { IJobsData } from '../../ssr/jobSearch'
import CompanyList from '../../components/Banners/FeaturedCompany'
import SearchJobsSection from '../../components/SearchJobs'
import UrgentJobsSection from '../../components/UrgentJobs'
import FeaturedJobsSection from '../../components/FeaturedJobs'
import { generateRequest } from '../../services/Jobs/helper'
import { JOB_SEARCH_LIMIT, retrieveFields } from '../../services/Jobs/const'
import SitemapBlock from '../../components/JobSearchPage/SitemapBlock'
import { useContext, useEffect } from 'react'
import AppContext from '../../context/AppContext'
import { UPDATE_USER } from '../../components/constants'
import { EMetaJobs } from '../../services/Jobs/@type'

interface IProps {
	langCode: ELanguage
	jobsData: IJobsData
	isRobotRequesting?: boolean
	isMobile?: boolean
}

export default function JobSearchContainer(props: IProps) {
	const { jobsData, isRobotRequesting, isMobile } = props
	const { user, languageCode: langCode } = useContext(AppContext)

	const t = (txt: string) => {
		const text = translator(txt, translate, langCode ?? ELanguage.VI)
		return text
	}
	const {
		totalJobsOnline,
		companies,
		urgentJobs,
		featuredJobs,
		partTimeJobs,
		highSalaryJobs,
		bestJobs,
		headhunterJobs,
		jobsByCities,
		jobsByIndustries,
		jobsByLevels,
		jobsByTypeWorkings
	} = jobsData

	const updateUserState = (e: Event) => {
		if (!e?.detail?.user) {
			return
		}
		window.location.reload()
	}

	useEffect(() => {
		window.addEventListener(UPDATE_USER, updateUserState)

		return () => {
			window.removeEventListener(UPDATE_USER, updateUserState)
		}
	}, [])

	return (
		<TransContext.Provider value={{ t }}>
			<Toast />
			<div id='pageContentWrapper'>
				<section className='topContent'>
					<Container>
						<h1>
							{totalJobsOnline ?? 0}{' '}
							{t(
								'recruitment news. Find a latest, quickly jobs 24 hours nationwide!'
							)}
						</h1>
						<p>
							{t(
								'Reach 10,000+ opportunities to apply for jobs at leading companies. New jobs every day with high salaries and good benefits.'
							)}
						</p>
					</Container>
				</section>
				<CompanyList
					languageCode={langCode ?? ELanguage.VI}
					companies={companies}
				/>
				<>
					<UrgentJobsSection
						jobs={urgentJobs}
						body={JSON.stringify(
							generateRequest(
								[
									{
										field: 'simpleServices',
										value: '"isUrgentJob","isUrgentJobM"'
									}
								],
								0,
								JOB_SEARCH_LIMIT,
								retrieveFields
							)
						)}
						sectionTitle={t('Urgent Jobs')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>

					<FeaturedJobsSection
						jobs={featuredJobs}
						languageCode={langCode}
						sectionTitle={t('Hot Jobs')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>

					<SearchJobsSection
						jobs={partTimeJobs}
						body={JSON.stringify(
							generateRequest(
								[
									{
										field: 'industries.industryId',
										value: '51'
									}
								],
								0,
								JOB_SEARCH_LIMIT,
								retrieveFields
							)
						)}
						sectionTitle={t('Part Time Jobs')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>

					<SearchJobsSection
						jobs={highSalaryJobs}
						body={JSON.stringify(
							generateRequest(
								[],
								0,
								JOB_SEARCH_LIMIT,
								retrieveFields,
								[
									{
										field: 'salary',
										value: 'desc'
									}
								]
							)
						)}
						sectionTitle={t('High Salary Works')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>

					<SearchJobsSection
						jobs={bestJobs}
						body={JSON.stringify(
							generateRequest(
								[],
								0,
								JOB_SEARCH_LIMIT,
								retrieveFields
							)
						)}
						sectionTitle={t('Best Jobs')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>

					<SearchJobsSection
						jobs={headhunterJobs}
						body={false}
						sectionTitle={t('Jobs From Top Headhunters')}
						slideWrapperClass={['featuredJobs']}
						user={user ?? null}
					/>
				</>
				<section className='sectionBlock mb-32'>
					<Container className='sitemapContent'>
						<div className='is-flex justify-between align-center'>
							<h2 className='sectionBlock__title'>
								{t('Hot Keywords')}
							</h2>
						</div>
						<div className='blockContent'>
							<div className='boxLeft'>
								{jobsByIndustries && (
									<SitemapBlock
										title={t('Search Job by Industry')}
										jobs={jobsByIndustries}
									/>
								)}

								{jobsByTypeWorkings && (
									<SitemapBlock
										title={t('Search Job by Working Type')}
										jobs={jobsByTypeWorkings}
									/>
								)}
							</div>

							<div className='boxRight'>
								{jobsByCities && (
									<SitemapBlock
										title={t('Jobs by Location')}
										jobs={jobsByCities}
										type={EMetaJobs.cities}
									/>
								)}
								{jobsByLevels && (
									<SitemapBlock
										title={t('Search Job by Level')}
										jobs={jobsByLevels}
									/>
								)}
							</div>
						</div>
					</Container>
				</section>
			</div>
		</TransContext.Provider>
	)
}
